import { DefaultTheme } from "styled-components/dist/types"


export const getAppContainerStyles = (theme: DefaultTheme): string => {
  return `
    height: 100vh;
    overflow: visible;
    background-color: ${theme.color.general.background};
    flex: 1;
  `
}